<template>
  <div class="item">
    <div class="item_top">
      <div class="item_top_img"><img :src="commentList.creator.avatar" /></div>
      <div class="item_top_name">{{commentList.creator.nickname}}</div>
    </div>
    <div class="item_content">{{commentList.content}}</div>
    <div class="item_btn">
      <div class="item_btn_reply" @click="replyStateFun()">返信</div>
      <div class="item_btn_time">{{getTime(commentList.createdDate)}}</div>
      <div class="item_btn_like" @click="likeFun(true)" v-bind:class="{ like: commentList.like }"><img v-if="!commentList.like" src="@/assets/imgs/article_like_left.png"><img v-if="commentList.like" src="@/assets/imgs/article_like_left_click.png">{{commentList.likeNum}}</div>
    </div>
    <div class="item_reply" v-if="replyState">
      <div class="reply">
        <textarea v-model="reply"></textarea>
      </div>
      <div class="btn" @click="replyCommentFun()">送信</div>
    </div>
    <div class="item_child_comment" v-for="item in childList">
      <div class="item_child_comment_top">
        <div class="item_child_comment_top_img"><img :src="item.creator.avatar" /></div>
        <div class="item_top_name">{{item.creator.nickname}}</div>
      </div>
      <div class="item_child_comment_content">
        {{item.content}}
      </div>
      <div class="item_child_comment_btn">
        <div class="item_child_comment_btn_time">{{getTime(item.createdDate)}}</div>
        <div class="item_child_comment_btn_like" @click="likeFun(item)" v-bind:class="{ like: item.like }"><img v-if="!item.like" src="@/assets/imgs/article_like_left.png"><img v-if="item.like" src="@/assets/imgs/article_like_left_click.png">{{item.likeNum}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { timeToStr } from '@/assets/js/util'
  import * as json from '@/assets/js/json'
  export default{
    props:{
      commentList:{
        type: Object,
        default: () => {
          return {}
        }
      },
      post:{
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    watch:{
      commentList(newVal,oldVal){
        this.getChildList()
      }
    },
    data() {
      return {
        childList:[],
        childLoading: false,
        replyState: false,
        reply: null
      }
    },
    created () {
      this.getChildList()
    },
    methods: {
      getTime(time){  
        return timeToStr(time)
      },
      replyStateFun(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        if(this.replyState){
          this.replyState = false
        }else{
          this.replyState = true
        }
      },
      replyCommentFun(){
        let option = {
          content : this.reply,
          postId : this.post.id,
          replyId : this.commentList.id
        }
        this.childLoading = true
        json.post('/api/member/post/comment/add',option).then(res =>{
          if(res.data.success){
            this.reply = null
            this.replyStateFun()
            this.getChildList()
            this.post.commentNum++
            this.childLoading = false
          }
        })
      },
      getChildList(){
        let option = {
          current : 1,
          PostCommentId : this.commentList.id
        }
        this.childLoading = true
        json.post('/api/member/post/comment/child/list',option).then(res =>{
          if(res.data.success){
            this.childList = res.data.data.page.records
            this.childLoading = false
          }
        })
      },
      likeFun(commentList){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        if(commentList!=true){
          let option = {
            commentId  : commentList.id
          }
          if(commentList.like){
            json.post('/api/member/post/comment/unlike',option).then(res =>{
              if(res.data.success){
                this.getChildList()
              }
            })
          }else{
            json.post('/api/member/post/comment/like',option).then(res =>{
              if(res.data.success){
                this.getChildList()
              }
            })
          }
        }else{
          let option = {
            commentId  : this.commentList.id
          }
          if(this.commentList.like){
            json.post('/api/member/post/comment/unlike',option).then(res =>{
              if(res.data.success){
                this.commentList.like = false
                this.commentList.likeNum --
              }
            })
          }else{
            json.post('/api/member/post/comment/like',option).then(res =>{
              if(res.data.success){
                this.commentList.like = true
                this.commentList.likeNum ++
              }
            })
          }
        }
        
      }
    },
  }
</script>

<style scoped>
  .item{
    padding: 12px 0px;
    border-top: 1px solid #ccc;
  }
  .item:first-child{
    border-top: 0px solid #ccc;
  }
  .item_top div{
    display: inline-block;
    vertical-align: top;
  }
  .item_top_img img{
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .item_top_name{
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    margin-left: 6px;
  }
  .item_content{
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
    margin: 7px;
  }
  .item_btn{
    height: 15px;
    font-size: 14px;
    font-weight: 300;
    color: #333333;
    line-height: 15px;
    margin: 0 7px;
    position: relative;
  }
  .item_btn_reply{
    cursor: pointer;
  }
  .item_btn div{
    display: inline-block;
  }
  .item_btn_time{
    position: absolute;
    left: 43px;
  }
  .item_btn_like{
    position: absolute;
    right: 0;
    line-height: 15px;
    cursor: pointer;
    vertical-align: bottom;
  }
  .item_btn_like img{
    width: 16px;
    height: 15px;
    font-size: 0;
    margin-right: 5px;
  }
  .like{
    color: #ff6633;
  }
  .item_reply{
    margin: 0 7px;
    margin-top: 12px;
    margin-bottom: 30px;
    position: relative;
  }
  .item_reply .reply textarea{
    width: 290px;
    height: 28px;
    resize:none;
    background: #EBEBEB;
    border-radius: 9px;
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
    outline: none;
    padding: 5px 10px;
  }
  .item_reply .btn{
    width: 71px;
    height: 23px;
    border: 1px solid #E4E4E4;
    border-radius: 8px;
    text-align: center;
    line-height: 23px;
    position: absolute;
    top: 49px;
    right: 0;
    cursor: pointer;
  }
  .item_child_comment{
    margin-top: 12px;
    margin-left: 6px;
  }
  .item_child_comment_top div{
    display: inline-block;
    vertical-align: top;
    line-height: 29px;
  }
  .item_child_comment_top_img img{
    width: 29px;
    height: 29px;
    border-radius: 50%;
    margin-right: 4px;
  }
  .item_child_comment_content{
    margin-left: 36px;
    margin-right: 7px;
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
  }
  .item_child_comment_btn div{
    display: inline-block;
    font-size: 14px;
    font-weight: 300;
    color: #666666;
    line-height: 15px;
  }
  .item_child_comment_btn{
    margin-left: 36px;
    margin-right: 7px;
    position: relative;
  }
  .item_child_comment_btn_like{
    position: absolute;
    right: 0;
    cursor: pointer;
  }
  .item_child_comment_btn_like img{
    width: 16px;
    height: 15px;
    vertical-align: bottom;
    margin-right: 5px;
  }
</style>